$(document).ready(function () {
	if (window.enterPopup == true) {
		$(window).scroll(function () {
			if (!$.cookie('newsletter_modal')) {
				if (window.pageYOffset > $(window).height() / 2) {
					$('.newsletter').fadeIn();
					var date = new Date();
					var days = 7;
					date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
					$.cookie('newsletter_modal', true, {
						path: '/',
						expires: date,
					});
				}
			}
		});
	}

	$('.newsletter .popup__close').click(function () {
		$('#popup-newsletter').fadeOut();
	});

	if (!$.cookie('cookie_bar')) {
		$('#cookie').fadeIn();
	}

	$('#cookie .cookie__btn').click(function () {
		$.cookie('cookie_bar', true, { path: '/' });
		$('.cookies').fadeOut();
	});

	$('.blog-subscribe').click(function () {
		$('.newsletter').fadeIn();
	});

	if (!$.cookie('notification')) {
		$('#notification').fadeIn();
	}

	$('#notification .notification__close').click(function () {
		$.cookie('notification', true, { path: '/' });
		$('.notification').fadeOut();
	});
});
